import handleColumnsResponse from './request/handleColumnsResponse'

export default function fetchCountry(api: GlobalFetch) {
  return async function(calendarId: number) {
    const response = await api.fetch(
      `/api/v2/calendar/days/id_calendar/${calendarId}`,
    )

    return await handleColumnsResponse(response)
  }
}
